/*
 * @Author: wp
 * @Date: 2023-01-03 15:36:13
 * @Descripttion:
 */
import md5 from 'js-md5'
import { checkRestrictMall } from '~/utils/validate'

export const state = () => ({
    defaultAvatar: 'https://oss.pzds.com/imgv2/defaultAvatar.png', // 默认头像
    infomationsImg: 'https://oss.pzds.com/mobile/zhucetouxiang1475.png', // 上传图片
    userAccount: null, // 用户个人中心小红点消息
    unreadNumber: null, // 系统消息未读数
    checkPayPass: false, // 是否设置过支付密码
    userAccountAlipay: null, // 支付宝账户
    thirdUserInfo: null, // 第三方信息
    qrUrl: null, // 微信公众号二维码
    userinfo: {}, // 用户个人信息存储
    token: null, // 登录token
    ryToken: null,
    noBargainSuccessTipTime: '', // 砍价成功不再提醒时间
    bargainSuccessId: '', // 砍价成功提醒订单Id
    couponDot: null, // 我的券包提示红点
    bannerColorCode: '', // 首页背景颜色
    restrictMall: [] // 用户限制列表
})
export const mutations = {
    SET_USERINFO: (state, userinfo) => {
        state.userinfo = userinfo;
        window.collectEvent('config', {
            user_unique_id: userinfo?.id || null
        })
    },
    SET_USER_ACCOUNT: (state, userAccount) => {
        state.userAccount = userAccount
    },
    SET_ACCOUNT_ALIPAY: (state, userAccountAlipay) => {
        state.userAccountAlipay = userAccountAlipay
    },
    SET_UNREAD_NUMBER: (state, number) => {
        state.unreadNumber = number
    },
    CHECK_PAY_PASS: (state, checkPayPass) => {
        state.checkPayPass = checkPayPass
    },
    THIRD_USERINFO: (state, thirdUserInfo) => {
        state.thirdUserInfo = thirdUserInfo
    },
    SET_WX_FOLLOW_QR: (state, qrUrl) => {
        state.qrUrl = qrUrl
    },
    SET_TOKEN: (state, token) => {
        state.token = token
    },
    SET_RY_TOKEN: (state, ryToken) => {
        state.ryToken = ryToken
    },
    SET_TIP_TIME: (state, tipTime) => {
        state.noBargainSuccessTipTime = tipTime
    },
    SET_BARGAIN_TIP_ID: (state, id) => {
        state.bargainSuccessId = id
    },
    SET_RYUSERID: (state, ryuserId) => {
        state.ryuserId = ryuserId
    },
    SET_USER_COUPON_DOT: (state, couponDot) => {
        state.couponDot = couponDot
    },
    SET_BANNER_COLOR: (state, col) => {
        state.bannerColorCode = col
    },
    SET_RESTRICT_MALL: (state, restrictMall) => {
        state.restrictMall = restrictMall
    }
}
export const actions = {
    UserGetInfo({ commit }) {
        return new Promise((resolve, reject) => {
            this.$api
                .getUserInfo()
                .then(res => {
                    this.$api.getImInfo().then(item => {
                        commit('SET_RY_TOKEN', item.data)
                    })
                    // 只在客户端操作localStorage
                    if (process.client) {
                        localStorage.setItem('setuserinfo', JSON.stringify(res.data))
                    }
                    commit('SET_USERINFO', res.data)
                    resolve(res)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    UserMobileCheck({ commit }, smsParams) {
        const { phone } = smsParams.action
        return new Promise((resolve, reject) => {
            this.$api
                .mobileCheck({ action: { phone } })
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    UserSendSms2({ commit }, smsParams) {
        return new Promise((resolve, reject) => {
            this.$api
                .sedSms2(smsParams)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    UserSendSms({ commit }, smsParams) {
        return new Promise((resolve, reject) => {
            this.$api
                .sedSms(smsParams)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    unreadMessageNumber({ commit }) {
        return new Promise((resolve, reject) => {
            this.$api
                .messageUnreadNumber()
                .then(response => {
                    if (response.success) {
                        commit('SET_UNREAD_NUMBER', response.data)
                    }

                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    // 收藏角标消息
    unreadMessageCollection() {
        return new Promise((resolve, reject) => {
            this.$api
                .messageUnreadCollection()
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },

    UserRegister({ commit }, userInfo) {
        const password = userInfo.action.password.toString()
        userInfo.action.password = md5(password)
        return new Promise((resolve, reject) => {
            this.$api
                .register(userInfo)
                .then(response => {
                    const data = response
                    if (data.success) {
                        const token = data.data.token
                        commit('SET_TOKEN', token)
                        // setToken(token); // 存在cookie中
                        this.$cookies.set('pzdsCookie', token)
                    }
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    // account login
    UserLogin({ commit }, userInfo) {
        const password = userInfo.action.password.toString()
        userInfo.action.password = md5(password)
        return new Promise((resolve, reject) => {
            this.$api
                .login(userInfo)
                .then(response => {
                    console.log('response', response)
                    const data = response
                    if (data.success) {
                        const token = data.data
                        commit('SET_TOKEN', token)
                        // setToken(token); // 存在cookie中
                        this.$cookies.set('pzdsCookie', token)
                    }
                    resolve(data)
                })
                .catch(error => {
                    console.log('error', error)
                    reject(error)
                })
        })
    },
    // account mobile login
    UserMobileLogin({ commit }, userInfo) {
        return new Promise((resolve, reject) => {
            this.$api
                .codeLogin(userInfo)
                .then(response => {
                    const data = response
                    if (data.success) {
                        const token = data.data.token
                        commit('SET_TOKEN', token)
                        // setToken(token); // 存在cookie中
                        this.$cookies.set('pzdsCookie', token)
                    }
                    resolve(data)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },

    UserGetWxFollow({ commit }) {
        return new Promise((resolve, reject) => {
            this.$api
                .getBindingQrCodeUrl()
                .then(res => {
                    commit('SET_WX_FOLLOW_QR', res.data.url)
                    resolve(res)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    // get account info
    UserCenterStatistics({ commit }) {
        return new Promise((resolve, reject) => {
            this.$api
                .userCenterStatistics()
                .then(res => {
                    console.log(res.data)

                    commit('SET_USER_ACCOUNT', res.data)
                    resolve(res)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    // 个人中心劵包提醒
    UserCenterCouponDot({ commit }) {
        return new Promise((resolve, reject) => {
            this.$api
                .getUserCenterNewCouponApi()
                .then(res => {
                    commit('SET_USER_COUPON_DOT', res.data)
                    resolve(res)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    // check account paypass
    UserCheckAccountWhetherSetPayPass({ commit }) {
        return new Promise((resolve, reject) => {
            this.$api
                .checkAccountWhetherSetPayPass()
                .then(res => {
                    commit('CHECK_PAY_PASS', res.data)
                    resolve(res)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },

    UserAccountAlipay({ commit }) {
        return new Promise((resolve, reject) => {
            this.$api
                .accountAlipay()
                .then(res => {
                    commit('SET_ACCOUNT_ALIPAY', res.data)
                    resolve(res)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    // account logout
    UserLogout({ commit, dispatch }) {
        return new Promise((resolve, reject) => {
            this.$api
                .logout()
                .then(res => {
                    commit('SET_USERINFO', null)
                    commit('SET_USER_ACCOUNT', null)
                    commit('SET_USER_ACCOUNT', null)
                    commit('SET_ACCOUNT_ALIPAY', null)
                    commit('SET_WX_FOLLOW_QR', null)
                    commit('SET_TOKEN', null)
                    commit('SET_RY_TOKEN', null)
                    commit('SET_BARGAIN_TIP_ID', null)
                    commit('SET_TIP_TIME', null)
                    dispatch('game/SET_RELEASE_DATA', {})
                    // removeToken();
                    //   resetRouter();
                    localStorage.removeItem('setuserinfo')
                    this.$cookies.remove('pzdsCookie')
                    resolve(res)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    // remove token
    UserResetToken({ commit }) {
        return new Promise(resolve => {
            commit('SET_USERINFO', null)
            commit('SET_USER_ACCOUNT', null)
            commit('SET_ACCOUNT_ALIPAY', null)
            commit('SET_TOKEN', null)
            // commit('SET_OSS_TOKEN', null, { root: true })
            //   resetRouter();
            // removeToken();
            localStorage.removeItem('setuserinfo')
            this.$cookies.remove('pzdsCookie')
            resolve()
        })
    },
    UserRestrictMall({ commit }) {
        return new Promise(resolve => {
            this.$api.getRestrictMallAPI().then(res => {
                commit('SET_RESTRICT_MALL', res.data)
                resolve(res)
            })
        })
    }
}
export const getters = {
    userinfo: state => state.userinfo,
    qrUrl: state => state.qrUrl,
    userAccount: state => state.userAccount,
    unreadNumber: state => state.unreadNumber,
    thirdUserInfo: state => state.thirdUserInfo,
    userAccountAlipay: state => state.userAccountAlipay,
    checkPayPass: state => state.checkPayPass,
    token: state => state.token,
    hasUserInfo: state => state.hasUserInfo,
    defaultAvatar: state => state.defaultAvatar,
    infomationsImg: state => state.infomationsImg,
    ryToken: state => state.ryToken,
    noBargainSuccessTipTime: state => state.noBargainSuccessTipTime,
    bargainSuccessId: state => state.bargainSuccessId,
    couponDot: state => state.couponDot,
    bannerColorCode: state => state.bannerColorCode,
    restrictMall: state => state.restrictMall,
    checkUserRestrictMall: state => code => {
        return checkRestrictMall(state.restrictMall, code)
    }
}
